// extracted by mini-css-extract-plugin
export default {"headerClass":"header_headerClass__-A37J","leftDiv":"header_leftDiv__Wp7fJ","rightDiv":"header_rightDiv__G3POk"};